var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unfavorite_chip_wrapper dark_bg_color pointer",on:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_c('v-icon',{attrs:{"color":"rgb(255, 89, 34)"}},[_vm._v(" mdi-heart-remove ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }